// Mocked until the wallet-service funding-request endpoints exist.
const approve = async ({ id, note }) => Promise.resolve({ data: { id, status: 'approved', note } });

const decline = async ({ id, note }) => Promise.resolve({ data: { id, status: 'rejected', note } });

const fundingRequests = {
  approve,
  decline,
};

export default fundingRequests;
